function StoryAbout() {
  return (
    <div className="StoryAbout">
      <div className="Container">
        <h1>Our Story</h1>
        <p className="Lead">
          Fingy arrived as a training guide for climbers, who strive to prepare
          for the rocks - as much as we do.
        </p>
      </div>
    </div>
  );
}

export default StoryAbout;
